import React from "react";

const EmpowerItem = ({ number, title, description }) => (
    <div className="empower-item">
        <div className="empower-line">
            <div className="dot" />
            <div className="number">{number}</div>
        </div>
        <div className="empower-content">
            <h3>{title}</h3>
            <p>{description}</p>
        </div>
    </div>
);

const WhoWeEmpowerMobile = () => {
    const items = [
        {
            number: "1",
            title: "Contractors",
            description:
                "Streamline project planning, task management, and compliance tracking while ensuring seamless coordination with teams and stakeholders.",
        },
        {
            number: "2",
            title: "Subcontractors",
            description:
                "Enhance efficiency with real-time task assignments, progress tracking, and integrated communication tools to keep projects on schedule.",
        },
        {
            number: "3",
            title: "Consultants",
            description:
                "Enhance efficiency with real-time task assignments, progress tracking, and integrated communication tools to keep projects on schedule.",
        },
        {
            number: "4",
            title: "Project Owners & Developers",
            description:
                "Gain complete project oversight with financial tracking, compliance monitoring, and data-driven insights to ensure successful project execution.",
        },
    ];

    return (
        <section className="empower-section">
            <h2>Who We Empower</h2>
            <p className="subtitle">
                Tailored Solutions for the Construction Industry
            </p>
            {items.map((item) => (
                <EmpowerItem key={item.number} {...item} />
            ))}
        </section>
    );
};

export default WhoWeEmpowerMobile;
